<template>
  <div class="wrapper">
    <!-- <div class="snap-status" v-show="loadSnapStatus">
      当前方案：{{ currentSnapInfo.name }}
      <a @click="quitSnap">退出</a>
    </div> -->

    <div class="panel" v-show="showPanel">
      <div class="title">保存&加载</div>
      <div class="action" style="display: flex;">
        <a-button type="primary" @click="showSaveDialog = true" :disabled="loadSnapStatus || calied_type !== 1"
          >保存方案</a-button
        >
        <a-button @click="getSnapshotList">加载方案</a-button>
      </div>
    </div>
    <a-button
      v-if="!showPanel"
      class="set-btn"
      icon="save"
      @click="showPanel = !showPanel"
    ></a-button>
    <a-button
      v-else
      class="set-btn set-btn-active"
      icon="close"
      @click="showPanel = !showPanel"
    ></a-button>

    <a-modal
      title="方案列表"
      v-model="showLoadDialog"
      width="800px"
      :footer="null"
    >
      <a-table
        :columns="columns"
        :rowKey="record => record.id"
        :dataSource="tableData"
        :loading="loading"
        size="small"
      >
        <template slot="detail" slot-scope="text, record">
          <!-- <a-button type="link">详情</a-button> -->
          <a-popover title="方案详情" trigger="click">
            <div slot="content">
              <div
                class="check-item-wrapper"
                v-for="i in record.typeList"
                :key="i"
              >
                <a-checkbox :checked="true" :disabled="true">
                  <span class="check-item-label">{{ name_options[i] }}</span>
                </a-checkbox>
              </div>

              <a-popconfirm
                title="确定要删除？"
                @confirm="deleteSnap(record.id)"
                okText="确定"
                cancelText="取消"
              >
                <a-button style="margin-top: 10px;" type="danger" size="small"
                  >删除</a-button
                >
              </a-popconfirm>
            </div>
            <a>详情</a>
          </a-popover>
        </template>
        <template slot="load" slot-scope="text, record">
          <a-button size="small" type="primary" @click="loadSnap(record)"
            >加载</a-button
          >
        </template>
        <!-- <template slot="is_custom" slot-scope="text, record">
          <span>{{ record.is_custom === '1' ? '是' : '否' }}</span>
        </template> -->
        <template slot="time_type" slot-scope="text, record">
          <span>{{ record.time_type | month_type_filter }}</span>
        </template>
        <template slot="summary_type" slot-scope="text, record">
          <span>{{ name_options[record.summary_type] }}</span>
        </template>
      </a-table>
    </a-modal>

    <a-modal
      title="保存方案"
      v-model="showSaveDialog"
      @ok="saveForm"
      :confirmLoading="confirmLoading"
    >
      <div class="item">
        方案名称：<a-input style="width: 100px" size="small" v-model="title" />
      </div>
      <div class="item">
        时间配置：{{ timeTypeDesc.name }}-{{ lineTStr }}
      </div>
      <div class="item">
        <span style="vertical-align: top;">数据详情：</span>
        <div style="display: inline-block">
          <div class="check-item-wrapper" style="border-top: 1px solid #e2e2e2">
            <a-checkbox
              :indeterminate="indeterminate"
              @change="onCheckAllChange"
              :checked="checkAll"
            >
              <span style="color: black">全选</span>
            </a-checkbox>
          </div>

          <div class="check-list-wrapper">
            <a-checkbox-group v-model="checkedList">
              <div
                class="check-item-wrapper"
                v-for="i in tpOptionsGetter"
                :key="i.value"
              >
                <a-checkbox :value="i.value" :disabled="i.disabled">
                  <span class="check-item-label">{{ i.name }}</span>
                </a-checkbox>
              </div>
            </a-checkbox-group>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";
import { getSnapshotList, saveSnapshot, archiveSnapshot } from "@/api/api";
import { name_options } from "@/options/option";
import { tpOptions, timeGroupOption } from '@/options/option'

const columns = [
  {
    title: "名称",
    dataIndex: "name"
  },
  {
    title: "时间类型",
    dataIndex: "time_type",
    scopedSlots: { customRender: "time_type" }
  },
  {
    title: "数据时间",
    dataIndex: "data_time"
  },
  {
    title: "创建时间",
    dataIndex: "saved_time",
    scopedSlots: { customRender: "saved_time" }
  },
  {
    title: "详情",
    dataIndex: "detail",
    scopedSlots: { customRender: "detail" }
  },
  {
    title: "加载",
    dataIndex: "load",
    scopedSlots: { customRender: "load" }
  }
];

export default {
  data() {
    return {
      name_options,
      columns,
      showPanel: false,
      showLoadDialog: false,
      showSaveDialog: false,
      loading: false,
      tableData: [],
      checkedList: [],
      indeterminate: true,
      checkAll: false,
      title: "",
      confirmLoading: false,
      detailVisible: false,
      customPeriodRangeWithFormat: [0,0],
    };
  },
  props: {
    sensortype: String,
    timeRangeType: Number,
    snapType: String
  },
  computed: {
    ...mapState([
      "userInfo",
      "loadSnapStatus",
      "currentSnapInfo",
      "projectInfo",
      "line_t",
      "time_type",
      "data_type",
      "calied_type"
    ]),
    ...mapGetters(["tpOptionsGetter", "lineTStr", "timeTypeDesc"]),
  },
  filters: {
    month_type_filter(v) {
      return timeGroupOption.find(x=>x.value2 === v).name
    }
  },
  watch: {
    showSaveDialog() {
      if (this.showSaveDialog) {
        this.title = "";
        this.checkedList = [];
      }
    }
  },
  methods: {
    getSnapshotList() {
      this.showLoadDialog = true;
      this.loading = true;
      getSnapshotList({ group_id: this.userInfo.userId })
        .then(x => {
          let d = x.data.data;
          d.forEach(i => {
            i.typeList = i.type.split(",");
          });
          d = this.$_.sortBy(d, ["saved_time"]).reverse();
          console.log(d);
          this.tableData = d;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    onCheckAllChange(e) {
      let all = this.tpOptionsGetter
        .filter(x => {
          return !x.disabled;
        })
        .map(x => {
          return x.value;
        });
      Object.assign(this, {
        checkedList: e.target.checked ? all : [],
        indeterminate: false,
        checkAll: e.target.checked
      });
    },
    validateForm() {
      let title = this.title.replace(/\s+/g, "");
      if (!title) {
        this.$message.info("请输入有效的名称");
        return false;
      }
      if (!this.checkedList.length) {
        this.$message.info("请选择至少一个数据项");
        return false;
      }
      return true;
    },
    saveForm() {
      let isValid = this.validateForm();
      let type = this.checkedList.join(",");
      let params;
      if (isValid) {
        this.confirmLoading = true;
        params = {
          group_id: this.userInfo.userId,
          name: this.title,
          time: this.lineTStr,
          time_type: this.time_type,
          type: type
        };
        saveSnapshot(params).then(x => {
          if (x.data.status === 0) {
            this.$message.success("保存成功");
          } else {
            this.$message.warning(x.data.msg);
          }
          this.confirmLoading = false;
          this.showSaveDialog = false;
        })
        .catch(e => {
          this.$message.error("操作失败");
          this.confirmLoading = false;
          this.showSaveDialog = false;
        });
      }
    },
    loadSnap(record) {
      console.log(record);
      this.showLoadDialog = false;
      this.$store.commit('setLoadSnapStatus', true)
      this.$store.commit('setCurrentSnapInfo', record)
      this.$store.commit('setTimeType', record.time_type)
      this.$store.commit('setDataType', record.typeList[0])
      this.$store.commit('setlineT', record.data_time)
      this.$emit("loadSnapShot")
    },
    quitSnap() {
      this.$store.commit("setLoadSnapStatus", false);
      this.$store.commit("setCurrentSnapInfo", {});
    },
    deleteSnap(id) {
      archiveSnapshot(id)
        .then(x => {
          if (x.data.status === 0) {
            this.$message.success("删除成功");
          } else {
            this.$message.success("删除失败");
          }
          this.getSnapshotList();
        })
        .catch(e => {
          console.log(e);
          this.$message.success("删除失败");
        });
    }
  }
};
</script>

<style scoped lang="less">
.wrapper {
  position: absolute;
  top: 50px;
  right: 10px;
  z-index: 8;
}

.set-btn {
  float: right;
  color: white;
  background-color: #085e9b;
  border-color: #085e9b;
}

.set-btn-active {
  background-color: red !important;
  border-color: red !important;
  color: white !important;

  &:hover {
    background-color: red;
    border-color: red;
    color: white;
  }
}

.panel {
  width: 200px;
  height: 100px;
  display: inline-block;
  background-color: white;
  padding: 10px;
  border-radius: 5px 0 5px 5px;

  .title {
    color: black;
    font-size: 18px;
    font-weight: bold;
  }

  .action {
    margin-top: 13px;
  }
}

.item {
  margin-bottom: 15px;
}

.check-list-wrapper {
  height: 100px;
  width: 220px;
  overflow-y: auto;
}

.check-item-wrapper {
  width: 200px;
  padding: 5px 10px;
  border-bottom: 1px solid #e2e2e2;
  border-left: 1px solid #e2e2e2;
  border-right: 1px solid #e2e2e2;

  .check-item-label {
    color: black;
  }
}

// .snap-status {
//   background-color: white;
//   display: inline-block;
//   vertical-align: top;
// }
</style>



// WEBPACK FOOTER //
// src/components/common/snapPanel.vue